<template>
  <div class="comment-form not-loggedin">
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <b-form @submit="onSubmit" @submit.stop.prevent>
        <div class="author-data d-flex flex-column flex-md-row mb-3">
          <div class="mr-md-3 mb-2 mb-md-0">
            <ValidationProvider rules="required|min:2|max:20" v-slot="{ errors }">
              <b-input-group id="input-group-author">
                <b-input-group-prepend is-text>
                  <b-icon icon="person-fill"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="input-author"
                              class="text-sm"
                              v-model="form.author"
                              type="text"
                              :placeholder="`${$t('auth.userName')}`"
                ></b-form-input>
              </b-input-group>
              <span class="error text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div>
            <ValidationProvider rules="required|email" v-slot="{ errors }">
              <b-input-group id="input-group-email">
                <b-input-group-prepend is-text>
                  <b-icon icon="at"></b-icon>
                </b-input-group-prepend>
                <b-form-input id="input-email"
                              class="text-sm"
                              v-model="form.email"
                              type="text"
                              :placeholder="`${$t('forms.emailAddress')}`"
                ></b-form-input>
              </b-input-group>
              <span class="error text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <ValidationProvider rules="required|min:2|max:500" v-slot="{ errors }">
          <div class="comment-field-wrapper mb-1">
            <b-form-textarea
              class="text-sm comment-field"
              v-model="form.comment"
              :placeholder="$t('comments.addComment')"
              rows="1"
              max-rows="5"
              @keydown.enter.prevent="onSubmit"
              ref="commentTextarea"
            ></b-form-textarea>
          </div>
          <span class="error text-sm">{{ errors[0] }}</span>
        </ValidationProvider>
        <span class="error text-sm">{{ error }}</span>
        <div class="d-flex justify-content-between flex-wrap">
          <div v-if="!$fromApp" class="mr-3">
            <span id="popover-not-loggedin-add-img">
              <button type="button"
                      class="btn btn-secondary btn-rounded text-sm disabled px-4 mt-3"
                      disabled>
                {{$t('common.addImages')}}
              </button>
              <b-popover
                target="popover-not-loggedin-add-img"
                :placement="'top'"
                triggers="hover focus"
              >
                <div class="popover-not-loggedin-content">
                  <h5 class="text-sm">{{$t('auth.youreNotLoggedIn')}}</h5>
                  <p class="text-sm font-weight-light m-0">
                    <localized-link :to="{name: 'Login'}">
                      <span class="text-secondary">{{$t('auth.login')}}</span>
                    </localized-link> {{$t('comments.or')}}
                    <localized-link :to="{name: 'Signup'}"><span class="text-secondary">{{$t('auth.register')}}</span></localized-link>
                  </p>
                </div>
              </b-popover>
            </span>
          </div>
          <div>
            <b-button type="submit"
                      :disabled="invalid || formSending"
                      class="btn btn-secondary btn-rounded text-sm px-4 mt-3 d-flex align-items-center">
              <span class="text-uppercase">{{$t('forms.send')}}</span>
              <b-spinner v-if="formSending" variant="light" small class="ml-2"></b-spinner>
            </b-button>
          </div>
        </div>
      </b-form>
    </ValidationObserver>
    <div v-if="isCommentHoldStatus" class="message text-secondary text-sm mt-3">
      <p class="bold mb-0">{{$t('comments.thankYouForComment')}}</p>
      <p v-html="$t('comments.commentSentToModeration')" class="m-0"></p>
    </div>
  </div>
</template>
<script>
import { i18n } from 'vue-lang-router';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import {
  required, email, max, min,
} from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: i18n.t('forms.thisFieldIsRequired'),
});
extend('email', {
  ...email,
  message: i18n.t('forms.emailNotValid'),
});
extend('min', {
  ...min,
  message: i18n.t('forms.atLeastCharacters'),
});
extend('max', {
  ...max,
  message: i18n.t('forms.maxCharacters'),
});

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    materialId: Number || String,
  },
  data() {
    return {
      form: {
        materialId: this.materialId,
        comment: '',
        author: '',
        email: '',
      },
      formSending: false,
      error: '',
      isCommentHoldStatus: false,
    };
  },
  methods: {
    onSubmit() {
      this.error = '';
      this.isCommentHoldStatus = false;
      this.$refs.observer.validate().then(() => {
        this.formSending = true;
        this.$store.dispatch('comment/SEND_COMMENT', this.form).then((response) => {
          this.formSending = false;
          this.isCommentHoldStatus = response.status === 'hold';
          this.form.comment = '';
          this.form.author = '';
          this.form.email = '';

          // Reset validation state
          // https://vee-validate.logaretm.com/v2/guide/components/validation-observer.html#resetting-forms
          requestAnimationFrame(() => {
            this.$refs.observer.reset();
          });
        }).catch((error) => {
          this.formSending = false;
          this.error = error;
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/app.scss';
.comment-form, .not-loggedin {
  padding: 1.5rem 2rem 2rem 3rem;
  border-radius: 8px;
}
.not-loggedin {
  background: $primary;
  color: white;
  a {
    color: $secondary;
  }
}
.comment-form {
  background-color: #e5e5e5;
  .comment-field-wrapper {
    position: relative;
  }
  .comment-field {
    border: 0;
    border-radius: 8px;
    overflow: auto!important;
    color: #787878;
    padding-right: 50px;
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .error {
    color: $tertiary;
    display: block;
  }
  .author-data > div {
    width: 100%;
  }
  .input-group-prepend > div {
    background: white;
  }
  input[type=text] {
    min-height: 34px;
  }
}
</style>
